import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import consts from '../../constant';

const getHeaders = () => ({
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
    },
});

export const fetchAdmin = createAsyncThunk(
    'user/fetchAdmin',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${consts.BackendUrl}/getAdmin`, {}, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState: {
        _id: "",
        email: "",
        name: "",
        permissions: [],
        role: "",
        phone: "",
        country: "",
        city: "",
        f2A_creds: {},
        verified: false,
        f2A_Status: false,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdmin.fulfilled, (state, action) => {
                state.loading = false;
                const result = action.payload.result;
                Object.assign(state, result);
                if (result?.access?.permissions) state.permissions = result.access.permissions;
            })
            .addCase(fetchAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default userSlice.reducer;
